/**
 * BannedPage.js
 * The "Blackhole" where expelled users are sent.
 */
import { logout } from "../auth.js";

export const BannedPage = () => {
    const container = document.createElement('div');
    container.className = "min-h-screen bg-black flex flex-col items-center justify-center text-center p-6 relative overflow-hidden";

    // 1. Blackhole Background Effect
    container.innerHTML = `
        <div class="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-purple-900/20 via-black to-black z-0"></div>
        <div class="absolute inset-0 z-0 animate-spin-slow opacity-30" style="background-image: radial-gradient(white 1px, transparent 1px); background-size: 50px 50px;"></div>
        
        <div class="relative z-10 max-w-md w-full bg-zinc-900/50 backdrop-blur-xl border border-red-900/30 p-8 rounded-2xl shadow-2xl shadow-red-900/20">
            <!-- Icon -->
            <div class="mb-6">
                <span class="material-symbols-outlined text-8xl text-red-600 animate-pulse">block</span>
            </div>

            <!-- Title -->
            <h1 class="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-red-500 to-purple-600 mb-2">
                CRITICAL ALERT
            </h1>
            <p class="text-gray-400 font-mono text-sm mb-6 uppercase tracking-widest">
                Access Denied: Level 5
            </p>

            <!-- Message -->
            <div class="bg-red-900/10 border border-red-500/20 rounded-lg p-4 mb-8 text-left">
                <p class="text-red-200 text-sm leading-relaxed">
                    <strong class="block text-red-500 mb-2 text-lg">"이놈!!" (ENOM!!)</strong>
                    당신의 계정은 썰화 월드의 규정을 심각하게 위반하여 <span id="ban-type" class="font-bold text-white">차단</span>되었습니다.<br><br>
                    관리자에 의해 모든 차원 연결이 끊어졌으며, 블랙홀 기록 보관소에 위반 내역이 영구 보존됩니다.
                </p>
                <div id="ban-reason-box" class="mt-4 pt-4 border-t border-red-500/20 hidden">
                    <p class="text-xs text-gray-500">사유:</p>
                    <p class="text-sm text-white font-mono" id="ban-reason">Unknown</p>
                </div>
                <div id="suspension-info-box" class="mt-4 pt-4 border-t border-red-500/20 hidden">
                    <p class="text-xs text-gray-500">해제 예정일:</p>
                    <p class="text-sm text-yellow-400 font-mono" id="suspension-date">Calculating...</p>
                </div>
            </div>

            <!-- Action -->
            <button id="btn-logout" class="w-full py-3 px-4 bg-zinc-800 hover:bg-zinc-700 text-white rounded-lg font-medium transition-colors duration-200 border border-zinc-700 flex items-center justify-center gap-2 group">
                <span class="material-symbols-outlined text-gray-400 group-hover:text-white">logout</span>
                현실로 귀환 (로그아웃)
            </button>
        </div>
    `;

    // 2. Logic: Show Reason or Suspension Date
    const user = window.user;
    if (user) {
        if (user.status === 'suspended') {
            const dateEl = container.querySelector('#suspension-date');
            const boxEl = container.querySelector('#suspension-info-box');
            const typeEl = container.querySelector('#ban-type');

            typeEl.textContent = "일시 정지";
            typeEl.className = "font-bold text-yellow-400";

            if (boxEl) boxEl.classList.remove('hidden');

            if (user.suspensionEndDate) {
                // Firestore Timestamp to Date
                const date = user.suspensionEndDate.toDate ? user.suspensionEndDate.toDate() : new Date(user.suspensionEndDate);
                dateEl.textContent = date.toLocaleString();
            }
        } else if (user.status === 'banned') {
            const typeEl = container.querySelector('#ban-type');
            typeEl.textContent = "영구 추방";
        }
    }

    // 3. Logout Handler
    container.querySelector('#btn-logout').onclick = async () => {
        await logout();
        window.location.hash = '/login';
    };

    return container;
};
